<template>
  <div class="studySource">
    <div class="studySource-centent">
        <img :src="LearningMaterialList.Cover||coverimg" alt="" class="studySource-centent-coverimg">
        <div class="studySource-centent-introduce">
            <h2>{{LearningMaterialList.Title}}</h2>
            <p style="margin-top:14px;">
                作者：{{LearningMaterialList.Autor}}
                <span style="width:50%;float:right;">出版时间：{{publishTime}}</span>
            </p>
            <p>ISBN：{{LearningMaterialList.ISBN}}</p>
            <p>教材链接：{{LearningMaterialList.Url}}</p>
            <p>
                出版社：{{LearningMaterialList.Press}}
                <span style="width:50%;float:right;">页数：{{LearningMaterialList.PageTotal}}</span>
            </p>
            <p style="margin-top:26px;">简介：</p>
            <div class="centent-introduce-abstract">
                <p class="abstract-check" v-if="isShow">{{Description}}</p>
                <p class="abstract-check" v-if="!isShow">{{LearningMaterialList.Description}}</p>
                <span class="check" v-if="isMore">
                    <span @click="clcikMore" v-if="isShow">查看更多 <i class="wl-icon-xiangxia"></i></span>
                    <span @click="clcikMore" v-if="!isShow">收起 <i class="wl-icon-shouqi"></i></span>
                </span>
            </div>
        </div>
        <div class="studySource-centent-tab">
            <div class="centent-tab-option fl" @click="getTab(index+1)" :class="{option:isTab==index+1}" v-for="(item,index) in optionData" :key="index">
                {{item}}
            </div>
        </div>
        <div class="centent-tab-catalo" v-if="isTab == 1"> 
            <!--<ul v-for="(item,index) in cataloData" :key="index">
                <li v-for="(items,index) in item" :key="index">
                    {{items}}
                </li>
            </ul>-->
            <p v-html="LearningMaterialList.Catalogue"></p>
        </div>
        <div class="centent-tab-catalo" v-if="isTab == 2"> 
            <p class="catalo-authorData">{{LearningMaterialList.AutorDescription}}</p>
        </div>
        <div class="centent-tab-catalo" v-if="isTab == 3"> 
            <div class="catalo-video fl" v-for="(item,index) in LearningSourceList" :key="index">
                <video :src="item.DocUrl" controls="controls" width="288px" height="162px;"></video>
                <p>{{item.DocTitle}}</p>
            </div>
            
        </div>
        <div class="centent-tab-catalo" v-if="isTab == 4"> 
            <p v-for="(item,index) in LearningSourceList" :key="index" class="resource">
                <a :href="item.DocUrl">
                <i class="wl-icon-word" v-if="item.DocExtension == '.doc' || item.DocExtension == '.docx'"></i>
                <i class="wl-icon-ppt" v-if="item.DocExtension == '.ppt'"></i>
                <i class="wl-icon-excel" v-if="item.DocExtension == '.xls' || item.DocExtension == '.xlsx'"></i>
                <i class="wl-icon-pdf" v-if="item.DocExtension == '.pdf'"></i>
                {{item.DocTitle}}
                </a>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "studySource",
  props: {
      sourseId:{
          type: String,
          default: ''
      }
  },
  data() {
    return {
        isShow: true,
        isMore: false,
        isTab:1,
        coverimg:require("assets/images/one-book.png"),
        videoData:'https://file.clpp.org.cn/66ykt/ori/z7owackpq7rmbl1lj0obrg/8JPGRHdJ2r7G4Bwp.mp4',
        optionData:['图书目录','作者简介','视频资源','文档资源'],
        introduceData:{
            title:'物流经理—日常工作细节',
            name:'田苗',
            date:'2019-05-20',
            number:'978-7-300-25879-9',
            link:'www.http://www.product.dangdang.com/26475648.html',
            press:'中国经济出版社',
            pages:'500页',
            abstract:'物流，是依托互联网不断繁荣的行业，物流从业者忙碌在各大中小企业里，随着市场对物流需求的迅猛增长，物流工作的水平亟待提高，物流工作中任何环节的疏忽都会造成很大的麻烦。因此，当务之急是提高物流经理的工作水平因此，当务之急是提高物流经理的工作水平因此，当务之急是提高物流经理的工作水平因此，当务之急是提高物流经理的工作水平'
        },
        cataloData:[
            [
                '第一章 古代美术欣赏',
                '第一节 史前美术',
                '第二节 古埃及美术',
                '第三节 古希腊美术',
                '第四节 古罗马美术'
            ],
            [
                '第二章 中世纪美术欣赏',
                '第一节 早期基督教美术',
                '第二节 拜占庭美术',
                '第三节 罗马式美术',
                '第四节 哥特式美术'

            ],
            [
                '第三章 文艺复兴时期西方美术欣赏',
                '第一节 文艺复兴时期意大利美术',
                '第二节 文艺复兴时期德国美术'
            ],
        ],
        authorData:'随着全球经济化速度的日益加快，物流作为企业经营运作的重要环节直接关系到企业的核心竞争力。根据劳动部1993[134]号文件的规定,为了与国际接轨，国家于2005年大力推行职业资格认证制度，要求五年内使80%物流从业人员必须持有相应的职业资格证书，物流业持证上岗将是大势所趋，物流贯穿企业的采购、生产、仓储、销售、运输、配送等环节，无论是生产企业还是第三方物流企业都面临着物流流程再造，而物流教育的滞后，使得物流人才非常匮乏，成为行业发展的瓶颈，物流人才也成为十大紧缺人才之一。',
        resourceData:[
            {
                fonttyoe:'wl-icon-word',
                name:'第一章 行业情况'
            },
            {
                fonttyoe:'wl-icon-ppt',
                name:'第二章 Maya基础'
            },
            {
                fonttyoe:'wl-icon-excel',
                name:'第四章 NURBS建模'
            },
            {
                fonttyoe:'wl-icon-pdf',
                name:'第四章 NURBS建模'
            },
        ],

        LearningSourceList:[],
        LearningMaterialList:[],
        docTyep:1,
        Description: '',
        publishTime:''
    };
  },
  created() {
      this.getLearningSource();
  },
    computed: {
        association: function() {
        return this.$store.state.association;
        }
    },
  methods:{
      goHome() {
        this.$router.push({
            name: "xHome"
        });
    },
    //获取详情数据
    getLearningSource(){
        debugger;
        var that = this;
        this.$http.post(
            '/api/XOrg/AssociationIndex/getLearningSource',
            {
                associationId: that.association.Id,
                learnId: that.sourseId,
                docType: that.docTyep
            }
        )
        .then(rst =>{
            if (rst.code == 1){
                that.publishTime = rst.publishTime;
                that.LearningSourceList = rst.list;
                that.LearningMaterialList = rst.learningList;
                if(rst.learningList.Description.length > 100){
                    that.isMore = true; 
                    that.Description = rst.learningList.Description.substring(0,100) + '...';
                } else {
                    that.Description = rst.learningList.Description;
                }
            }else {
                that.$message.warning(rst.msg);
            }
        })
    },
    clcikMore(){
        this.isShow = !this.isShow;
    },
    getTab(number){
        this.isTab = number;
        if (this.isTab == 3){
            this.docTyep = 1;
            this.getLearningSource();
        }else if(this.isTab == 4){
            this.docTyep =2;
            this.getLearningSource();
        }
    }
  }
};
</script>

<style>
</style>
